<template>
  <b-form @submit.prevent="loginSubmit">
    <h2>Inloggen</h2>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.username" required/>
    </b-input-group>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" class="form-control" placeholder="Wachtwoord" v-model="form.password"
                    required/>
    </b-input-group>
    <p v-if="loginError" class="text-danger">
      {{ loginError }}
    </p>
    <b-row>
      <b-col cols="6">
        <b-button variant="primary" class="px-4 btn-block" type="submit" :disabled="loggingIn">
          Inloggen
          <b-spinner v-show="loggingIn" small type="grow"/>
        </b-button>
      </b-col>
      <b-col cols="6" class="text-right mt-2">
        <a href="/forgot-password" class="px-0">Wachtwoord vergeten</a>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'Login',
        data() {
            return {
                form: {
                    username: null,
                    password: null,
                }
            }
        },
        methods: {
            ...mapActions([
                'doLogin'
            ]),
            loginSubmit() {
              const {username, password } = this.form;
                this.doLogin({
                    username,
                    password
                })
            }
        },
        computed: {
            ...mapState([
                'loggingIn',
                'loginError'
            ])
        },
    }
</script>
